import React, { useLayoutEffect, useRef } from 'react'
import { gsap } from 'gsap'

export default function Hamburger({ open, setOpen }) {
  const defaultLines = 'w-full h-[1px] bg-white'
  const target = useRef()
  const tl = useRef()
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline()
        .to('.top', {
          y: '5px',
        })
        .to(
          '.bottom',
          {
            y: '-5px',
          },
          '<'
        )
    }, target)
  }, [])
  useLayoutEffect(() => {
    //* Need to find a better way to handle tl speed and direction
    if (!open) {
      tl.current.timeScale(1.15)
      tl.current.reverse()
    } else {
      tl.current.timeScale(1)
      tl.current.play()
    }
  }, [open])
  return (
    <div
      className="w-[30px] flex flex-col gap-2 md:hidden"
      ref={target}
      onClick={() => setOpen(!open)}
      onKeyDown={() => setOpen(!open)}
      role="button"
      tabIndex={0}
    >
      <div className={`${defaultLines} top`} />
      <div className={`${defaultLines} bottom`} />
    </div>
  )
}
